import { createSlice } from "@reduxjs/toolkit";
import { staticVar } from "../services/Constants";
import { selectIcon } from "../components/UI/selector";
import { CheckValue } from "../services/CommonFunction";

const initialState = {
  data: {
    first_name: "",
    last_name: "",
    email: "",
    roles: [],
    gyms: [],
    selectedGym: {},
    payment_settings: null,
    membership_code: undefined,
    profile_pic_original: selectIcon("userDummy"),
    profile_pic_thumb: selectIcon("userDummy"),
  },
  status: staticVar.idle,
};

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    addUserData: {
      reducer(state, action) {
        state = {
          data: action.payload,
          status: staticVar.done,
        };
      },
      prepare(data) {
        return {
          payload: data,
        };
      },
    },
    // updateUserData: (state, action) => {
    //     let selectedGym  = {...state.data.selectedGym};
    //     if( CheckValue(action.payload.gyms) && action.payload.gyms.length) {
    //         state.data.gyms = action.payload.gyms;
    //     }
    //     if(CheckValue(action.payload.selectedGym)) {
    //         selectedGym = {...action.payload.selectedGym};
    //         if(state.data.gyms.length) {
    //             state.data.gyms.forEach(el => {
    //                 if(el.membership_code === selectedGym.membership_code) {
    //                     el = {...selectedGym}
    //                 }
    //             });
    //         }
    //     }
    //     if(CheckValue(action.payload.membership_code) && action.payload.membership_code.length) {
    //         if(state.data.gyms.length) {
    //             const gym =  state.data.gyms.filter(el => el.membership_code === action.payload.membership_code);
    //             if(gym.length) {
    //                 selectedGym = gym[0];
    //             } else {
    //                 selectedGym = state.data.gyms[0];
    //                 action.payload.membership_code = state.data.gyms[0].membership_code;
    //             }
    //         }
    //     // } else if( CheckValue(action.payload.gyms) && action.payload.gyms.length) {
    //     //     selectedGym = action.payload.gyms[0];
    //     }
    //     if(Object.keys(selectedGym).length) {
    //         staticVar.app_id = selectedGym.app_id;
    //     }
    //     state.data = {
    //         ...state.data,
    //         ...action.payload,
    //         ...selectedGym,
    //     }
    // },
    updateUserData: (state, action) => {
      let selectedGym = {};
      if (CheckValue(action.payload.selectedGym)) {
        selectedGym = { ...action.payload.selectedGym };
        const gyms = [...state.data.gyms];
        gyms.forEach((el) => {
          if (el.membership_code === selectedGym.membership_code) {
            el = { ...selectedGym };
          }
        });
        state.data.gyms = gyms;
      }
      if (
        CheckValue(action.payload.membership_code) &&
        action.payload.membership_code
      ) {
        let gyms = state.data.gyms;
        if (CheckValue(action.payload.gyms) && action.payload.gyms.length) {
          gyms = action.payload.gyms;
        }
        if (gyms.length) {
          const gym = gyms.filter(
            (el) => el.membership_code === action.payload.membership_code
          );
          if (gym.length) {
            selectedGym = gym[0];
          } else {
            selectedGym = gyms[0];
            action.payload.membership_code = gyms[0].membership_code;
          }
        }
      } else if (
        CheckValue(action.payload.gyms) &&
        action.payload.gyms.length
      ) {
        selectedGym = action.payload.gyms[0];
      }
      if (Object.keys(selectedGym).length) {
        staticVar.app_id = selectedGym.app_id;
      }
      state.data = {
        ...state.data,
        ...action.payload,
        ...selectedGym,
      };
    },
    updatePaymentOption: (state, action) => {
      if (CheckValue(state.data.gyms) && state.data.gyms.length) {
        const index = state.data.gyms.findIndex(
          (el) => el.membership_code === state.data.membership_code
        );
        state.data.gyms[index].payment_settings = {
          ...state.data.gyms[index].payment_settings,
          ...action.payload,
        };
      }
      state.data.selectedGym.payment_settings = {
        ...state.data.selectedGym.payment_settings,
        ...action.payload,
      };
    },
    updateGymkey: (state, action) => {
      console.log(action.payload);
      if (CheckValue(state.data.gyms) && state.data.gyms.length) {
        const index = state.data.gyms.findIndex(
          (el) => el.membership_code === state.data.membership_code
        );
        state.data.gyms[index] = {
          ...state.data.gyms[index],
          ...action.payload,
        };
      }
      state.data.selectedGym = {
        ...state.data.selectedGym,
        ...action.payload,
      };
    },
    updateLocationStatus: (state, action) => {
      if (CheckValue(state.data.gyms) && state.data.gyms.length) {
        const index = state.data.gyms.findIndex(
          (el) => el.membership_code === state.data.membership_code
        );
        state.data.gyms[index].is_location_enabled = action.payload;
      }
      state.data.selectedGym.is_location_enabled = action.payload;
    },
    resetUserData: (state) => {
      state.data = initialState.data;
      state.status = initialState.status;
    },
  },
});

export const selectUserData = (state) => state.userData.data;
export const selectedGymData = (state) => state.userData.data.selectedGym;
export const {
  addUserData,
  resetUserData,
  updateUserData,
  updatePaymentOption,
  updateGymkey,
  updateLocationStatus,
} = userDataSlice.actions;
export default userDataSlice.reducer;
